import { shallowEqual } from "react-redux";
import { useAppSelector } from "../store/hooks";
import { ServiceProvider } from "../interfaces/ServiceProvidersInterface";

interface UseServiceProvidersOptions {
  active?: boolean;
}

/**
 * Custom hook to fetch service providers from the Redux store.
 * Uses shallowEqual to ensure a stable reference and prevent infinite loops.
 */
export const useServiceProviders = (
  options: UseServiceProvidersOptions = {}
): Array<ServiceProvider> => {
  const { active = true } = options;

  return useAppSelector((state) => {
    const sps = state.resources.resourceCentreServiceProviders || [];
    return active ? sps.filter((sp: ServiceProvider) => sp.active === true) : sps;
  }, shallowEqual);
};

export default useServiceProviders;
